/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type FspType = typeof FspType[keyof typeof FspType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FspType = {
  MNO: 'MNO',
  BANK: 'BANK',
  DIRECT_DEPOSIT: 'DIRECT_DEPOSIT',
} as const;
